// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../ASSETS/BACKGROUND/homeHeroBg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Homepage hero.
   >= 1200px: text column on the shared content edge, photo column bleeding to
   the right edge behind a curved mask. Below that, the photo is a full-width
   banner above the text so it is never squeezed into a narrow column.
   The header is fixed; on the unscrolled homepage its large logo hangs to
   ~130px, so content starts below --logo-clearance plus scaled breathing room. */

.homeHero_hero__297M9 {
  --logo-clearance: 130px;
  --breathing: clamp(1.75rem, 5svh, 3.5rem);
  --arc: clamp(6px, 0.9vw, 14px);

  position: relative;
  display: flex;
  background: var(--color-ink) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  color: var(--color-text-on-dark);
  font-family: var(--font-sans);
  overflow: clip;
  isolation: isolate;
}
.homeHero_hero__297M9::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(90deg, rgba(18, 21, 26, 0.96) 0%, rgba(18, 21, 26, 0.86) 48%, rgba(18, 21, 26, 0.55) 100%);
}

/* Soft gold light behind the copy; drifts with the cursor. */
.homeHero_glow__Vf3jy {
  position: absolute;
  z-index: 0;
  left: -12vw;
  top: 8%;
  width: min(60vw, 820px);
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(closest-side, rgba(255, 215, 0, 0.13), rgba(255, 215, 0, 0.04) 55%, transparent 72%);
  pointer-events: none;
}

.homeHero_inner__QJxL0 {
  position: relative;
  z-index: 1;
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

/* ---------- Copy ---------- */
.homeHero_copy__IVjLB {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-5);
  padding: var(--space-6) var(--gutter) var(--space-8);
}
.homeHero_title__OmIk1 {
  margin: 0;
  /* width in em keeps "Making / progress / possible." on three lines at any size */
  max-width: 6.6em;
  font-family: var(--font-display);
  font-size: clamp(2.6rem, 1.6rem + 4.2vw, 5.25rem);
  font-weight: 400;
  line-height: 1.04;
  letter-spacing: -0.01em;
}
/* Each headline line rises out of its own mask. Padding keeps descenders
   (g, p) inside the mask. */
.homeHero_line__r0DsR {
  display: block;
  overflow: hidden;
  padding-bottom: 0.14em;
  margin-bottom: -0.14em;
}
.homeHero_lineInner__iKoYq {
  display: inline-block;
  transform-origin: 0% 100%;
}
.homeHero_accent__wQ6j\\+ {
  color: var(--color-accent);
  background: linear-gradient(180deg, #fff27a 0%, var(--kur-gold) 55%, #e8b800 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.homeHero_lead__LldQb {
  margin: 0;
  max-width: 33rem;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  color: var(--color-text-muted-on-dark);
}
.homeHero_actions__erMMt {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3) var(--space-3);
  margin-top: var(--space-2);
}
/* forces the text link onto its own line, sharing the buttons' left edge */
.homeHero_break__IeQll {
  flex-basis: 100%;
  height: 0;
}
.homeHero_textCta__\\+5hCD {
  margin-top: var(--space-1);
}

/* Gene Therapy Ready seal: under the CTAs on stacked layouts, a badge on the
   photo in the two-column layout. */
.homeHero_seal__1wgcI,
.homeHero_badge__hZ7wX {
  display: flex;
  align-items: center;
  gap: var(--space-4);
}
.homeHero_seal__1wgcI img,
.homeHero_badge__hZ7wX img {
  flex: none;
  width: 3.25rem;
  height: 3.25rem;
  object-fit: contain;
}
.homeHero_seal__1wgcI p,
.homeHero_badge__hZ7wX p {
  margin: 0;
  font-size: var(--text-caption);
  line-height: 1.5;
}
.homeHero_seal__1wgcI {
  max-width: 30rem;
  padding-top: var(--space-5);
  border-top: 1px solid var(--color-border-on-dark);
  color: var(--color-text-muted-on-dark);
}
.homeHero_badge__hZ7wX {
  display: none;
}

/* ---------- Photo ----------
   Source is 16:9 with the in-focus vial at ~70% x and the face at ~45% x.
   A percentage object-position scales with the visible fraction, so 60%
   keeps face and vial in frame whether the panel is square-ish or wide. */
.homeHero_visual__MRjPd {
  position: relative;
  order: -1;
  width: 100%;
  margin-top: calc(var(--logo-clearance) + var(--space-5));
  aspect-ratio: 4 / 3;
  max-height: 58svh;
}
.homeHero_arc__rapto,
.homeHero_mask__qf8l- {
  position: absolute;
  inset: 0;
  clip-path: ellipse(80% 100% at 50% 0%);
}
/* Metallic gold edge with a soft glow. */
.homeHero_arc__rapto {
  bottom: calc(var(--arc) * -1);
  background: linear-gradient(160deg, #fff6a8 0%, var(--kur-gold) 30%, #f0b800 62%, #ffe34d 100%);
  filter: drop-shadow(0 0 18px rgba(255, 205, 0, 0.35));
  animation: homeHero_revealBanner__aUhOm 1.1s var(--ease-out) 0.05s backwards;
}
.homeHero_mask__qf8l- {
  overflow: hidden;
  animation: homeHero_revealBanner__aUhOm 1.1s var(--ease-out) 0.1s backwards;
}
.homeHero_drift__VOwnA {
  position: absolute;
  inset: 0;
  will-change: transform;
}
.homeHero_photo__QMYld {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 60% 42%;
  transform-origin: 60% 45%;
}
/* One diagonal light sweep across the photo after it lands. */
.homeHero_sheen__-Wv5x {
  position: absolute;
  /* starts just off the left edge; travels past the right edge */
  inset: -10% auto -10% -45%;
  width: 45%;
  background: linear-gradient(100deg, transparent 0%, rgba(255, 255, 255, 0.22) 45%, rgba(255, 255, 255, 0.34) 50%, rgba(255, 255, 255, 0.22) 55%, transparent 100%);
  mix-blend-mode: soft-light;
  pointer-events: none;
}
/* Subtle top-light gloss over the whole photo. */
.homeHero_mask__qf8l-::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, transparent 35%, rgba(18, 21, 26, 0.18) 100%);
  pointer-events: none;
}
@keyframes homeHero_revealBanner__aUhOm {
  from {
    clip-path: ellipse(80% 0% at 50% 0%);
  }
}
@keyframes homeHero_revealSide__wQeJq {
  from {
    clip-path: ellipse(0% 80% at 100% 50%);
  }
}

/* ---------- Phones ---------- */
@media (max-width: 480px) {
  .homeHero_actions__erMMt {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .homeHero_actions__erMMt > a {
    width: 100%;
  }
  .homeHero_textCta__\\+5hCD {
    align-self: flex-start;
    width: auto !important;
  }
}

/* ---------- Tablets and small laptops: wide banner above the copy ---------- */
@media (min-width: 600px) and (max-width: 1199px) {
  .homeHero_visual__MRjPd {
    aspect-ratio: 16 / 9;
  }
  .homeHero_copy__IVjLB {
    padding-inline: max(var(--gutter), calc((100% - 46rem) / 2));
  }
}

/* Landscape tablets / small laptops: a shorter banner keeps the headline on
   the first screen; the vertical crop stays centred on the eyes and vial. */
@media (min-width: 600px) and (max-width: 1199px) and (orientation: landscape) {
  .homeHero_visual__MRjPd {
    max-height: 40svh;
  }
  .homeHero_photo__QMYld {
    object-position: 60% 40%;
  }
}

/* ---------- Desktop: two columns ---------- */
@media (min-width: 1200px) {
  .homeHero_hero__297M9 {
    /* content decides the height; the floor/ceiling keep the photo panel wide
       enough that it is never forced into a tall, zoomed-in crop */
    min-height: clamp(38rem, 78svh, 52rem);
  }
  .homeHero_inner__QJxL0 {
    grid-template-columns:
      [full-start] minmax(var(--gutter), 1fr)
      [content-start] minmax(0, calc(var(--container) * 0.46))
      [middle] minmax(0, calc(var(--container) * 0.54))
      [content-end] minmax(var(--gutter), 1fr)
      [full-end];
  }
  .homeHero_copy__IVjLB {
    grid-column: content-start / middle;
    grid-row: 1;
    justify-content: center;
    padding: calc(var(--logo-clearance) + var(--breathing)) var(--space-6) var(--space-7) 0;
  }
  .homeHero_seal__1wgcI {
    display: none;
  }
  .homeHero_visual__MRjPd {
    grid-column: middle / full-end;
    grid-row: 1;
    order: 0;
    margin-top: 0;
    aspect-ratio: auto;
    max-height: none;
  }
  .homeHero_arc__rapto,
  .homeHero_mask__qf8l- {
    clip-path: ellipse(100% 80% at 100% 50%);
    animation-name: homeHero_revealSide__wQeJq;
  }
  .homeHero_arc__rapto {
    inset: 0 0 0 calc(var(--arc) * -1);
  }
  .homeHero_photo__QMYld {
    object-position: 60% 50%;
  }
  .homeHero_badge__hZ7wX {
    display: flex;
    position: absolute;
    z-index: 2;
    right: max(var(--gutter), calc((100vw - var(--container)) / 2));
    bottom: clamp(1.25rem, 4svh, 2.5rem);
    max-width: 23rem;
    padding: 0.75rem 1.1rem 0.75rem 0.75rem;
    border-radius: var(--radius-md);
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: linear-gradient(160deg, rgba(40, 45, 52, 0.72), rgba(14, 17, 21, 0.78));
    backdrop-filter: blur(14px) saturate(140%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), 0 18px 40px -18px rgba(0, 0, 0, 0.6);
    color: #fff;
  }
}

/* Short desktop screens: scale the headline with height so the CTA row stays
   above the fold. */
@media (min-width: 1200px) and (max-height: 820px) {
  .homeHero_copy__IVjLB {
    gap: var(--space-4);
    padding-bottom: var(--space-6);
  }
  .homeHero_title__OmIk1 {
    font-size: clamp(2.6rem, 10svh, 5.25rem);
  }
  .homeHero_lead__LldQb {
    font-size: 1.05rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .homeHero_arc__rapto,
  .homeHero_mask__qf8l- {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/HERO/homeHero.module.css"],"names":[],"mappings":"AAAA;;;;;iFAKiF;;AAEjF;EACE,uBAAuB;EACvB,yCAAyC;EACzC,8BAA8B;;EAE9B,kBAAkB;EAClB,aAAa;EACb,6FAAyG;EACzG,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sHAAsH;AACxH;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,OAAO;EACP,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gHAAgH;EAChH,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oDAAoD;AACtD;AACA;EACE,SAAS;EACT,iFAAiF;EACjF,gBAAgB;EAChB,gCAAgC;EAChC,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;4BAC4B;AAC5B;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,kFAAkF;EAClF,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;AACA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;oCACoC;AACpC;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,UAAU;EACV,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iDAAiD;EACjD,sCAAsC;AACxC;AACA;EACE,aAAa;AACf;;AAEA;;;0EAG0E;AAC1E;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,wDAAwD;EACxD,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,sCAAsC;AACxC;AACA,yCAAyC;AACzC;EACE,6BAA6B;EAC7B,+FAA+F;EAC/F,qDAAqD;EACrD,4EAA4D;AAC9D;AACA;EACE,gBAAgB;EAChB,2EAA2D;AAC7D;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,+DAA+D;EAC/D,0BAA0B;EAC1B,UAAU;EACV,kKAAkK;EAClK,0BAA0B;EAC1B,oBAAoB;AACtB;AACA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+GAA+G;EAC/G,oBAAoB;AACtB;AACA;EACE;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,oBAAoB;EACtB;EACA;IACE,4DAA4D;EAC9D;AACF;;AAEA;4EAC4E;AAC5E;EACE;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE;mEAC+D;IAC/D,sCAAsC;EACxC;EACA;IACE;;;;;gBAKY;EACd;EACA;IACE,mCAAmC;IACnC,WAAW;IACX,uBAAuB;IACvB,uFAAuF;EACzF;EACA;IACE,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,WAAW;IACX,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;EACA;;IAEE,wCAAwC;IACxC,0CAA0B;EAC5B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,+DAA+D;IAC/D,oCAAoC;IACpC,gBAAgB;IAChB,uCAAuC;IACvC,+BAA+B;IAC/B,2CAA2C;IAC3C,mFAAmF;IAEnF,0CAA0C;IAC1C,yFAAyF;IACzF,WAAW;EACb;AACF;;AAEA;oBACoB;AACpB;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Homepage hero.\n   >= 1200px: text column on the shared content edge, photo column bleeding to\n   the right edge behind a curved mask. Below that, the photo is a full-width\n   banner above the text so it is never squeezed into a narrow column.\n   The header is fixed; on the unscrolled homepage its large logo hangs to\n   ~130px, so content starts below --logo-clearance plus scaled breathing room. */\n\n.hero {\n  --logo-clearance: 130px;\n  --breathing: clamp(1.75rem, 5svh, 3.5rem);\n  --arc: clamp(6px, 0.9vw, 14px);\n\n  position: relative;\n  display: flex;\n  background: var(--color-ink) url(\"../../../../ASSETS/BACKGROUND/homeHeroBg.jpg\") center / cover no-repeat;\n  color: var(--color-text-on-dark);\n  font-family: var(--font-sans);\n  overflow: clip;\n  isolation: isolate;\n}\n.hero::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: linear-gradient(90deg, rgba(18, 21, 26, 0.96) 0%, rgba(18, 21, 26, 0.86) 48%, rgba(18, 21, 26, 0.55) 100%);\n}\n\n/* Soft gold light behind the copy; drifts with the cursor. */\n.glow {\n  position: absolute;\n  z-index: 0;\n  left: -12vw;\n  top: 8%;\n  width: min(60vw, 820px);\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: radial-gradient(closest-side, rgba(255, 215, 0, 0.13), rgba(255, 215, 0, 0.04) 55%, transparent 72%);\n  pointer-events: none;\n}\n\n.inner {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n/* ---------- Copy ---------- */\n.copy {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-5);\n  padding: var(--space-6) var(--gutter) var(--space-8);\n}\n.title {\n  margin: 0;\n  /* width in em keeps \"Making / progress / possible.\" on three lines at any size */\n  max-width: 6.6em;\n  font-family: var(--font-display);\n  font-size: clamp(2.6rem, 1.6rem + 4.2vw, 5.25rem);\n  font-weight: 400;\n  line-height: 1.04;\n  letter-spacing: -0.01em;\n}\n/* Each headline line rises out of its own mask. Padding keeps descenders\n   (g, p) inside the mask. */\n.line {\n  display: block;\n  overflow: hidden;\n  padding-bottom: 0.14em;\n  margin-bottom: -0.14em;\n}\n.lineInner {\n  display: inline-block;\n  transform-origin: 0% 100%;\n}\n.accent {\n  color: var(--color-accent);\n  background: linear-gradient(180deg, #fff27a 0%, var(--kur-gold) 55%, #e8b800 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.lead {\n  margin: 0;\n  max-width: 33rem;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted-on-dark);\n}\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-3) var(--space-3);\n  margin-top: var(--space-2);\n}\n/* forces the text link onto its own line, sharing the buttons' left edge */\n.break {\n  flex-basis: 100%;\n  height: 0;\n}\n.textCta {\n  margin-top: var(--space-1);\n}\n\n/* Gene Therapy Ready seal: under the CTAs on stacked layouts, a badge on the\n   photo in the two-column layout. */\n.seal,\n.badge {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n}\n.seal img,\n.badge img {\n  flex: none;\n  width: 3.25rem;\n  height: 3.25rem;\n  object-fit: contain;\n}\n.seal p,\n.badge p {\n  margin: 0;\n  font-size: var(--text-caption);\n  line-height: 1.5;\n}\n.seal {\n  max-width: 30rem;\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--color-border-on-dark);\n  color: var(--color-text-muted-on-dark);\n}\n.badge {\n  display: none;\n}\n\n/* ---------- Photo ----------\n   Source is 16:9 with the in-focus vial at ~70% x and the face at ~45% x.\n   A percentage object-position scales with the visible fraction, so 60%\n   keeps face and vial in frame whether the panel is square-ish or wide. */\n.visual {\n  position: relative;\n  order: -1;\n  width: 100%;\n  margin-top: calc(var(--logo-clearance) + var(--space-5));\n  aspect-ratio: 4 / 3;\n  max-height: 58svh;\n}\n.arc,\n.mask {\n  position: absolute;\n  inset: 0;\n  clip-path: ellipse(80% 100% at 50% 0%);\n}\n/* Metallic gold edge with a soft glow. */\n.arc {\n  bottom: calc(var(--arc) * -1);\n  background: linear-gradient(160deg, #fff6a8 0%, var(--kur-gold) 30%, #f0b800 62%, #ffe34d 100%);\n  filter: drop-shadow(0 0 18px rgba(255, 205, 0, 0.35));\n  animation: revealBanner 1.1s var(--ease-out) 0.05s backwards;\n}\n.mask {\n  overflow: hidden;\n  animation: revealBanner 1.1s var(--ease-out) 0.1s backwards;\n}\n.drift {\n  position: absolute;\n  inset: 0;\n  will-change: transform;\n}\n.photo {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 60% 42%;\n  transform-origin: 60% 45%;\n}\n/* One diagonal light sweep across the photo after it lands. */\n.sheen {\n  position: absolute;\n  /* starts just off the left edge; travels past the right edge */\n  inset: -10% auto -10% -45%;\n  width: 45%;\n  background: linear-gradient(100deg, transparent 0%, rgba(255, 255, 255, 0.22) 45%, rgba(255, 255, 255, 0.34) 50%, rgba(255, 255, 255, 0.22) 55%, transparent 100%);\n  mix-blend-mode: soft-light;\n  pointer-events: none;\n}\n/* Subtle top-light gloss over the whole photo. */\n.mask::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, transparent 35%, rgba(18, 21, 26, 0.18) 100%);\n  pointer-events: none;\n}\n@keyframes revealBanner {\n  from {\n    clip-path: ellipse(80% 0% at 50% 0%);\n  }\n}\n@keyframes revealSide {\n  from {\n    clip-path: ellipse(0% 80% at 100% 50%);\n  }\n}\n\n/* ---------- Phones ---------- */\n@media (max-width: 480px) {\n  .actions {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n  .actions > a {\n    width: 100%;\n  }\n  .textCta {\n    align-self: flex-start;\n    width: auto !important;\n  }\n}\n\n/* ---------- Tablets and small laptops: wide banner above the copy ---------- */\n@media (min-width: 600px) and (max-width: 1199px) {\n  .visual {\n    aspect-ratio: 16 / 9;\n  }\n  .copy {\n    padding-inline: max(var(--gutter), calc((100% - 46rem) / 2));\n  }\n}\n\n/* Landscape tablets / small laptops: a shorter banner keeps the headline on\n   the first screen; the vertical crop stays centred on the eyes and vial. */\n@media (min-width: 600px) and (max-width: 1199px) and (orientation: landscape) {\n  .visual {\n    max-height: 40svh;\n  }\n  .photo {\n    object-position: 60% 40%;\n  }\n}\n\n/* ---------- Desktop: two columns ---------- */\n@media (min-width: 1200px) {\n  .hero {\n    /* content decides the height; the floor/ceiling keep the photo panel wide\n       enough that it is never forced into a tall, zoomed-in crop */\n    min-height: clamp(38rem, 78svh, 52rem);\n  }\n  .inner {\n    grid-template-columns:\n      [full-start] minmax(var(--gutter), 1fr)\n      [content-start] minmax(0, calc(var(--container) * 0.46))\n      [middle] minmax(0, calc(var(--container) * 0.54))\n      [content-end] minmax(var(--gutter), 1fr)\n      [full-end];\n  }\n  .copy {\n    grid-column: content-start / middle;\n    grid-row: 1;\n    justify-content: center;\n    padding: calc(var(--logo-clearance) + var(--breathing)) var(--space-6) var(--space-7) 0;\n  }\n  .seal {\n    display: none;\n  }\n  .visual {\n    grid-column: middle / full-end;\n    grid-row: 1;\n    order: 0;\n    margin-top: 0;\n    aspect-ratio: auto;\n    max-height: none;\n  }\n  .arc,\n  .mask {\n    clip-path: ellipse(100% 80% at 100% 50%);\n    animation-name: revealSide;\n  }\n  .arc {\n    inset: 0 0 0 calc(var(--arc) * -1);\n  }\n  .photo {\n    object-position: 60% 50%;\n  }\n  .badge {\n    display: flex;\n    position: absolute;\n    z-index: 2;\n    right: max(var(--gutter), calc((100vw - var(--container)) / 2));\n    bottom: clamp(1.25rem, 4svh, 2.5rem);\n    max-width: 23rem;\n    padding: 0.75rem 1.1rem 0.75rem 0.75rem;\n    border-radius: var(--radius-md);\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    background: linear-gradient(160deg, rgba(40, 45, 52, 0.72), rgba(14, 17, 21, 0.78));\n    -webkit-backdrop-filter: blur(14px) saturate(140%);\n    backdrop-filter: blur(14px) saturate(140%);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), 0 18px 40px -18px rgba(0, 0, 0, 0.6);\n    color: #fff;\n  }\n}\n\n/* Short desktop screens: scale the headline with height so the CTA row stays\n   above the fold. */\n@media (min-width: 1200px) and (max-height: 820px) {\n  .copy {\n    gap: var(--space-4);\n    padding-bottom: var(--space-6);\n  }\n  .title {\n    font-size: clamp(2.6rem, 10svh, 5.25rem);\n  }\n  .lead {\n    font-size: 1.05rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .arc,\n  .mask {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `homeHero_hero__297M9`,
	"glow": `homeHero_glow__Vf3jy`,
	"inner": `homeHero_inner__QJxL0`,
	"copy": `homeHero_copy__IVjLB`,
	"title": `homeHero_title__OmIk1`,
	"line": `homeHero_line__r0DsR`,
	"lineInner": `homeHero_lineInner__iKoYq`,
	"accent": `homeHero_accent__wQ6j+`,
	"lead": `homeHero_lead__LldQb`,
	"actions": `homeHero_actions__erMMt`,
	"break": `homeHero_break__IeQll`,
	"textCta": `homeHero_textCta__+5hCD`,
	"seal": `homeHero_seal__1wgcI`,
	"badge": `homeHero_badge__hZ7wX`,
	"visual": `homeHero_visual__MRjPd`,
	"arc": `homeHero_arc__rapto`,
	"mask": `homeHero_mask__qf8l-`,
	"revealBanner": `homeHero_revealBanner__aUhOm`,
	"drift": `homeHero_drift__VOwnA`,
	"photo": `homeHero_photo__QMYld`,
	"sheen": `homeHero_sheen__-Wv5x`,
	"revealSide": `homeHero_revealSide__wQeJq`
};
export default ___CSS_LOADER_EXPORT___;
